<template>
<PopupCover v-if="previewData" @close="closePopup()">
    <PopupBody @close="() => closePopup()" class="preview-popup">
      <template #header>{{`${errorList && errorList.length ?'Errors detected during validation' : 'Information Preview'}`}}</template>
      <template #body>
        <div class="flex column align-center gap-20 main-table">
          <div v-if="errorList && errorList.length" class="w-full flex column align-start gap-20">
            
            <div v-if="nonTableErrors.length" class="flex column gap-5px align-start">
              <b>{{  nonTableErrors.length }} error{{ nonTableErrors.length > 1 ? 's' : '' }} found in user provided data.</b> Please fix the errors and try again.

              <div class="error flex gap-5px align-center" v-for="row in nonTableErrors">
                <span class="dot"></span> {{ row.errorText }}
              </div>
            </div>
            <div class="font-size-14 " v-if="tableErrors.length">
              <b>{{  tableErrors.length }} error{{ tableErrors.length > 1 ? 's' : '' }} found in the file.</b> Please fix the errors and try again.
            </div>
            <div class="toggle flex gap-20px align-center toggle-error" v-if="tableErrors.length">
              <div @click="goBack()" class="flex pointer toggle-elem">
                <img src="@/assets/arrow-white.svg" alt="back" style="width: 20px; transform: rotate(-90deg);" />
              </div>
              <div>Error {{currentError}} of {{ tableErrors.length }}</div>
              <div @click="goForward()" class="flex pointer toggle-elem">
                <img src="@/assets/arrow-white.svg" alt="back" style="width: 20px; transform: rotate(90deg);" />

              </div>
            </div>
          </div>
          <div v-if="hasDatabaseValues" class="w-full text-left font-size-14 flex gap-5px align-center">
            <span class="db-swatch"></span> Filled automatically from your imported player data
          </div>
          <div class="preview">
            <table >
              <thead>
                <tr>
                  <th v-for="(item, index) in header" :class="`tabel-head`" >
                    {{ item.value }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, indexRow) in body" :key="`${indexRow}-preview-row`">
                  <td v-for="(headrProp, index) in header" :key="`${index}-preview-item`"
                      :class="{ 'from-database': isFromDatabase(row, headrProp.column) }"
                      :title="isFromDatabase(row, headrProp.column) ? 'Filled automatically from imported player data' : null">
                    <div v-if="findError(indexRow, headrProp.column)" class="flex gap-5px align-center relative" :data-error-key="'error-' + indexRow + '-' + headrProp.column.replaceAll(' ', '-')">
                      <div class="error-cell">{{ findError(indexRow, headrProp.column) }}</div>
                      {{ columnValue(row, headrProp.column) }}
                    </div>
                    <div v-else>
                      {{ columnValue(row, headrProp.column) }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </PopupBody>
  </PopupCover>
</template>

<script setup>
    import PopupBody from '@/components/PopupBody.vue';
    import PopupCover from '@/components/PopupCover.vue';
    import { onMounted, ref, computed, defineEmits } from 'vue';
    import { excelDateToString, excelTimeToString } from '@/utils/fiu_utils.js';


    const header = ref(null);
    const body = ref(null);

    const emit = defineEmits(['downloadFile', 'close']);
    const props = defineProps({
        previewData: {
          type: Array,
          required: true,
        },
        simplified: {
          type: Boolean,
          default: false,
        },
        errorList: {
          type: Array,
          default: null,
        }
    });
    
    const currentError = ref(1);
    const tableErrors = computed(() => {
      if (!props.errorList) return 0;
      return props.errorList.filter(error => error.columnName);
    });
    const nonTableErrors = computed(() => {
      if (!props.errorList) return 0;
      return props.errorList.filter(error => !error.columnName);
    });
    onMounted(() => {
      const tmp = [...props.previewData];
      header.value = tmp.shift();
      console.log('header', header.value);
      body.value = tmp;
      setTimeout(() => {
        if(tableErrors.value.length) {
          const error = tableErrors.value[0];
          const key = `[data-error-key="error-${error.index}-${error.columnName.replaceAll(' ', '-')}"]`

          const element = document.querySelector(key);
          
          animate(element);
        }
      }, 50)
    })
    function goBack(){
      if (currentError.value > 1) {
        currentError.value -= 1;
        const error = tableErrors.value[currentError.value - 1];
        const element = document.querySelector(`[data-error-key="error-${error.index}-${error.columnName.replaceAll(' ', '-')}"]`);
        animate(element);
      }
    }
    function goForward(){
      if (currentError.value < tableErrors.value.length) {
        currentError.value += 1;
        const error = tableErrors.value[currentError.value - 1];
        const element = document.querySelector(`[data-error-key="error-${error.index}-${error.columnName.replaceAll(' ', '-')}"]`);
        animate(element);
      }
    }
  
    function closePopup() {
        emit('close');
    }
    const hasDatabaseValues = computed(() => (props.previewData || []).slice(1).some(row => row.some(item => item.fromDatabase)));
    function isFromDatabase(row, column) {
      return !!row.find(item => item.column == column)?.fromDatabase;
    }
    function columnValue(row, column) {
      const headerItem = row.find(item => item.column == column);
      return headerItem?.value;
    }
    
    function findError(indexRow, column) {
      if (!props.errorList) return '';
      const error = props.errorList.find(item => item.index == indexRow && item.columnName == column);
      if (error) {
        return `Error: ${error.errorText}`;
      }
      return '';
    }
    function animate(element) {
      console.log('element', element);
      if (!element) {
        return;
      }
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      element.parentNode.classList.add('highlight');
      setTimeout(() => {
        element.parentNode.classList.remove('highlight');
      }, 2000);
    }
</script>



<style scoped lang="scss">

    .main-table {
      overflow: auto;
    }
    .preview-popup {
        width: 95vw;
        max-height: 95vh;
        box-sizing: border-box;
        display: flex;
        background: white;
        border-radius: 15px;
        color: black;
        z-index: 100;
        top: 0;
        left: 0;
        
    }
    .popup-body {
        background: white;
        border-radius: 15px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #close-popup {
        position: absolute;
        img {
            width: 30px;
        }
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
    .confirm-button {
        padding: 15px;
        font-size: 14px;
        width: fit-content;
        margin-top: 20px;
    }
    .preview {
        background: white;
        overflow-y: auto;
        width: 100%;
    }
    td, th {
      width: fit-content;
      white-space: nowrap;
      padding: 5px 10px;
      font-size: 16px;
      outline: 0.5px solid #bbbaba;
      &.modified {
          background-color: #afaf00;
          outline: 2px #afaf00 solid;
      }
    }
    td.from-database {
      background-color: #e3efff;
    }
    .db-swatch {
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 3px;
      background: #e3efff;
      border: 1px solid #bbb;
    }
    .error-cell {
      background-color: #D06A69;
      color: white;
      padding: 0px 10px;
      border-radius: 5px;
      // position: absolute ;
    }
    .toggle-error {
      background-color: #D06A69;
      color: white;
      padding: 5px;
      border-radius: 5px;
      gap: 10px;
    }
    .highlight {
      animation: highlightAnimation 2s ease-in-out;
    }

    @keyframes highlightAnimation {
      0% {
        background-color: #D06A69;
      }
      33% {
        background-color: transparent;
      }
      66% {
        background-color: #D06A69;
      }
      100% {
        background-color: transparent;
      }
    }
    .toggle-elem {
      padding: 5px;
      border-radius: 5px;
      &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      }
    }
    .dot {
      height: 5px;
      width: 5px;
      background-color: black;
      border-radius: 50%;
      display: inline-block;
    }
</style>